<template>
    <div class="ma-4">
        <v-alert v-model="errorActive" type="error" border="left" color="red lighten-1" dismissible>
            {{ messages.error }}
        </v-alert>
        <v-alert v-model="successActive" type="success" border="left" color="green lighten-1" dismissible>
            {{ messages.success }}
        </v-alert>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
    name: "alert",
    computed: {
        ...mapGetters(['messages']),
        errorActive: {
            get() {
                return this.messages.error?.length > 0
            },
            set() {
                this.$store.dispatch('setError', "")
            }
        },
        successActive: {
            get() {
                return this.messages.success?.length > 0
            },
            set() {
                this.$store.dispatch('setSuccess', "")
            }
        }
    },
}
</script>
